// import _ from 'underscore';
import { useCallback, useState, useMemo, useEffect } from 'react';
import { odata } from '@bingads-webui/http-util';

import { useOdataOptions } from './use-odata-options';

export const useAudienceData = ({
  postponeFetch = false,
  pathOverride = undefined,
  audienceType = undefined,
  deliverychannel = undefined,
} = {}) => {
  const [OdataOptions, { aid, cid }] = useOdataOptions(pathOverride);

  const endPoint = `Customers(${cid})/Accounts(${aid})/Audiences`;

  const options = useMemo(() => ({
    ...OdataOptions,
    url: endPoint,
    data: {
      $orderby: 'Name',
      audiencetype: audienceType || 'Remessaging,Custom,InMarket,Product,RemarketingSimilar,CustomerList,CombinedList',
      deliverychannel: deliverychannel || 'BingAds,AIM',
    },
    // Only enable cache for InMarket audience type
    ...(audienceType === 'InMarket' && { cache: true }),
  }), [OdataOptions, endPoint, audienceType, deliverychannel]);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);

  const getAudienceData = useCallback(() => {
    setIsLoading(true);

    return odata.get(options)
      .then((res) => {
        const { value = [] } = (res as any) || {};
        setData(value);

        return value;
      })
      .catch(err => Promise.reject(err))
      .finally(() => {
        setIsLoading(false);
      });
  }, [options]);

  useEffect(() => {
    if (!postponeFetch) {
      getAudienceData();
    }
  }, [getAudienceData, postponeFetch]);

  return [{ isLoading, data }, getAudienceData];
};
